/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCommentDto } from '../../models/contents-request-comment-dto';

export interface ContentsRequestCommentControllerFindById$Params {
  id: string;
}

export function contentsRequestCommentControllerFindById(http: HttpClient, rootUrl: string, params: ContentsRequestCommentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestCommentControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestCommentDto>;
    })
  );
}

contentsRequestCommentControllerFindById.PATH = '/api/contents-request-comment/{id}';
